import { Dialog } from "@/components/ui/dialog/dialog";
import { StandardFrame } from "@/components/ui/frames/standard-frame";
import { SimpleButton } from "@/components/ui/buttons/simple-button";
import { PokemonBoxData } from "types/web-app";
import { TrashIcon } from "@/icons";

interface DeleteBoxConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  box: PokemonBoxData | null;
  isLoading?: boolean;
}

export const DeleteBoxConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  box,
  isLoading,
}: DeleteBoxConfirmDialogProps) => {
  if (!isOpen || !box) return null;

  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeOnBackdrop={!isLoading}>
      <StandardFrame
        variant="red"
        className="w-[90%] max-w-md max-h-[90vh]"
      >
        <div className="flex flex-col gap-4 p-3">
        <div className="text-center">
        
          <h2 className="text-2xl font-bold text-white mb-2 uppercase tracking-wider">
            Delete Squad
          </h2>
          <p className="text-white/80 mb-4">
            Are you sure you want to delete <strong>"{box.name}"</strong>?
          </p>
          <div className="bg-red-500/20 p-4 rounded-lg mb-6 border border-red-500/30">
           
            <p className="text-white/70 text-sm leading-relaxed">
              All Pokémon in this squad will be moved to your default squad.
            </p>
          </div>
          <div className="flex gap-3 mt-6">
            <SimpleButton
              onClick={onClose}
              variant="gray"
              className="flex-1"
              disabled={isLoading}
            >
              Cancel
            </SimpleButton>
            <SimpleButton
              onClick={onConfirm}
              variant="red"
              className="flex-1"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete Squad"}
            </SimpleButton>
          </div>
        </div>
        </div>
      </StandardFrame>
    </Dialog>
  );
};